import React, { useContext, useRef, useState, useEffect, useMemo } from 'react';
import './LoyaltyFoldFlying.css';
import { GeneralLoyaltyDataService } from '../../../../loyalty/src/services/general-loyalty-data.service';
import { LoyaltyFold } from '../LoyaltyFold';
import { AsgFwContext } from '../../contexts';
import { LoyaltyShortInfo } from '../../../../loyalty/src/components/LoyaltyShortInfo';
import { LoyaltyPlansEnum } from '../../../../loyalty/src/enums/loyalty-plans.enum';

export const LoyaltyFoldFlying = ({
    isVisible,
}) => {
    const AsgFW = useContext(AsgFwContext);
    const flyingFoldRef = useRef(null);
    const [blockWidth, setBlockWidth] = useState(245);
    const isOneOfDefaultPlansUsed = useMemo(() => GeneralLoyaltyDataService.isOneOfDefaultPlansUsed(), []);

    const baseClass = 'loyalty-fold-flying';
    const loyaltyPlan = useMemo(() => GeneralLoyaltyDataService.getLoyaltyPlan(), []);
    const wrapperClass = [
        baseClass,
        `${baseClass}--${loyaltyPlan}`,
        isVisible ? `${baseClass}--visible` : '',
    ].join(' ');
    const wrapperStyles = useMemo(() => {
        if (loyaltyPlan !== LoyaltyPlansEnum.EDITABLE_DEFAULT) {
            return {};
        }

        const wrapperStyles = {};
        const totalWidth = window.innerWidth;
        const parentLeft = flyingFoldRef?.current?.parentElement?.offsetLeft || 0;
        /* as per design */
        const maxShift = 40;
        const minGap = 30;

        wrapperStyles.left = maxShift;

        const restWidth = totalWidth - parentLeft;
        const gap = restWidth - blockWidth - maxShift;

        if (gap < minGap) {
            wrapperStyles.left = restWidth - blockWidth - minGap;
        }

        wrapperStyles.left += 'px';

        return wrapperStyles;
    }, [blockWidth, flyingFoldRef?.current?.parentElement?.offsetLeft]);

    useEffect(() => {
        if (flyingFoldRef?.current?.offsetWidth) {
            setBlockWidth(flyingFoldRef.current.offsetWidth);
        }
    }, [flyingFoldRef?.current?.offsetWidth]);

    return <div
        className={wrapperClass}
        style={wrapperStyles}
        ref={flyingFoldRef}
    >
        {isOneOfDefaultPlansUsed && <LoyaltyFold
            userLoyaltyPoints={AsgFW.getLoyaltyPoints()}
            clickHandler={() => AsgFW.showMyRewards()}
        />}
        {!isOneOfDefaultPlansUsed && <LoyaltyShortInfo />}
    </div>;
};
